


































































































































































































































































































































/*
  getParam 获取评卷教师评价页面参数
  getMarkTchEvaluate 获取评卷教师评价分页列表
  manualEvaluate 手工评价
  addBlackList 加入黑名单
  removeBlackList 移出黑名单
*/
import { Vue, Component } from "vue-property-decorator";
//引入接口调用函数
import {
  getParam,
  getMarkTchEvaluate,
  manualEvaluate,
  addBlackList,
  removeBlackList,
  printContract
} from "../../../api/markingTeacherEvaluate";
//引入导入、导出、下载的处理函数
import importAndExportMixin from "../../../mixins/importAndExport";

//自定义对象接口
interface CustomForm {
  [propName: string]: any;
}

@Component({
  name: "projectManage",
  components: {
    teacherEvaluate: () => import("./module/teacherEvaluate.vue"),
    UploadProgress: () => import("@/components/UploadProgress/index.vue"),
  },
  mixins: [importAndExportMixin]
})
export default class extends Vue {
  private projectId: string = ""; //项目id
  private projectLabel: string = ""; //项目展示标签
  private evaluateStatus: number | null = null; //评价状态 0:未评 1:已评
  private isRecommend: number | null = null; //是否推荐 是:0, 否:1
  private employState: string = ""; //聘用状态
  private isBlacklist: number | null = null; //是否黑名单 0:否,1:是
  private schoolName: string = ""; //单位名称
  private teacherName: string = ""; //评卷教师
  private teacherIsBlacklist: string = ""; //黑名单
  private showTableLoading: boolean = false; //是否显示列表loading
  private tableData: object[] = []; //列表数据
  private pageNo: number = 1; //当前页码
  private pageSize: number = 10; //当前条目
  private total: number = 0; //总条数
  private chooseIdArray: string[] = []; //勾选的数据id集合
  private chooseRowArray: object[] = []; //勾选的数据row 集合
  private dialogFormVisible: boolean = false; //是否显示添加\编辑弹窗
  private editForm: CustomForm = {}; //添加\编辑弹窗的数据
  private showTeacherEvaluate: boolean = false; //是否显示详情
  private currentTeacherEvaluate: object = {}; //当前显示的评价详情
  private orderObj: any = { orderBy: "", order: "" }; //当前排序的对象 { 排序字段, 升序/降序 }
  private isExcellent:string = "" //是否优秀教师
  private showAdvancedSearch: boolean = false; //是否显示高级筛选
  //页面参数
  private projects: object[] = []; //项目数组
  private subjects: object[] = []; //科目数组
  private tableHeight: number = 0;
  public $refs!: {
    table: HTMLFormElement;
  };
  private iframe:any = null  //装载pdf的iframe对象
  private uploadData = {progressId: -1, projectId: this.projectId}; // 文件上传入参
  created() {
    //初始化data数据
    this.initDta();
    //获取页面参数
    this.getParams();
    //获取列表
    this.getData();
  }

  mounted() {
    setTimeout(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 80;
      if (this.tableHeight < 300) { this.tableHeight = 300; }
    }, 100);
  }

  beforeDestroy() {
    // 释放文件引用
    if (this.iframe && this.iframe.src) {
      window.URL.revokeObjectURL(this.iframe.src);
    }
  }

  initDta() {
    const { projectLabel, projectId } = this.$route.query;
    if (projectLabel && projectId) {
      this.projectId = projectId as string;
      this.projectLabel = projectLabel as string;
    }
  }

  //上传地址
  get uploadUrl() {
    return window.config.baseUrl4Shool + "/markteacher/markTchEvaluate/upload";
  }

  // 根据分页计算页码
  private indexMethod(index) {
    return index + 1 + (this.pageNo - 1) * this.pageSize;
  }

  // private getIndex () {
  //   return this.pageNo * 10 + this.pageNo
  // }

  //获取页面参数
  private async getParams() {
    let res = await getParam();
    try {
      let res = await getParam();
      // this.projects = res.data;
      this.projects = res.data.projects;
      this.subjects = res.data.subjects; // 科目参数
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //获取列表数据
  private async getData() {
    this.showTableLoading = true;
    let params = {
      current: this.pageNo, //当前页
      size: this.pageSize, //记录数
      evaluateState: this.evaluateStatus, //评价状态 0:未评 1:已评
      teacherIsBlacklist: this.teacherIsBlacklist, //是否黑名单 0:否,1:是
      otherinfoIsRecommend: this.isRecommend, //是否推荐 是:0, 否:1
      projectId: this.projectId, //项目id
      schoolName: this.schoolName, //所属学校名称
      teacherName: this.teacherName, //教师姓名
      employState: this.employState, //聘用状态
      otherinfoIsExcellentTeacher:this.isExcellent
    };
    if (this.orderObj.orderBy) {
      //排序字段
      params[this.orderObj.orderBy] = this.orderObj.order;
    }
    try {
      let res = await getMarkTchEvaluate(params);
      this.showTableLoading = false;
      this.tableData = res.data.records;
      this.total = res.data.total;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //搜索查询
  private searchHandle() {
    this.pageNo = 1;
    this.getData();
  }

  //重置搜索条件
  private resetSearch() {
    this.projectId = "";
    this.evaluateStatus = null;
    this.isRecommend = null;
    this.employState = "";
    this.isBlacklist = null;
    this.schoolName = "";
    this.teacherName = "";
    this.teacherIsBlacklist = "";
    this.isExcellent = "";
    this.pageNo = 1;
    this.getData();
  }

  //勾选处理
  private selectChangeHandle(v: object[]) {
    //记录只勾选一个时的数据
    if (v.length == 0) return false;
    // 用户如果勾选多条，未做处理
    this.currentTeacherEvaluate = JSON.parse(JSON.stringify(v[0]));
    //整理勾选的教师id数组
    this.chooseIdArray = v.map((item: any) => {
      return item.teacherId;
    });
    // 勾选的单行的内容 -- 用于打印优秀证书/ 加入黑名单/移出黑名单等
    this.chooseRowArray = [...v];
  }

  //点击“加入黑名单”
  private showAddBlackListDialog() {
    // if (this.chooseIdArray.length <= 0) {
    //   this.$message.warning("请先勾选！");
    //   return;
    // }
    if (this.chooseRowArray.length <= 0) {
      this.$message.warning("请先勾选！");
      return;
    }
    this.dialogFormVisible = true;
  }

  //加入黑名单的“保存”处理
  private async saveEditHandle() {
    // 流程改之前
    // let params = {
    //   blacklistReason: this.editForm.reason, //加入黑名单的原因
    //   ids: this.chooseIdArray, //教师id
    //   projectId: this.projectId //项目id
    // };
    // 流程改之后
    let tempArr: Array<object> = [];
    this.chooseRowArray.forEach(v => {
      tempArr.push({
        blacklistReason: this.editForm.reason, //加入黑名单的原因
        teacherId: v[`teacherId`], //教师id
        projectId: v[`projectId`] //项目id
      });
    });
    try {
      await addBlackList(tempArr);
      this.$message.success("加入成功");
      this.dialogFormVisible = false;
      this.getData();
    } catch (error) {
      // this.$message.error(error || "加入失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //移出黑名单
  private async removeBlackListHandle() {
    // if (this.chooseIdArray.length <= 0) {
    //   this.$message.warning("请先勾选！");
    //   return;
    // }
    if (this.chooseRowArray.length <= 0) {
      this.$message.warning("请先勾选！");
      return;
    }
    // let params = {
    //   ids: this.chooseIdArray, //教师id
    //   projectId: this.projectId //项目id
    // };
    // 流程改之后
    let tempArr: Array<object> = [];
    this.chooseRowArray.forEach(v => {
      tempArr.push({
        teacherId: v[`teacherId`], //教师id
        projectId: v[`projectId`] //项目id
      });
    });
    try {
      await removeBlackList(tempArr);
      this.$message.success("移出成功");
      this.getData();
    } catch (error) {
      // this.$message.error(error || "移出失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //排序处理
  private sortChange(v: { column: object; prop: string; order: string }) {
    let { column, prop, order } = v;
    //判断排序字段，获取列表数据
    switch (prop) {
      //工作量（h）
      case "markingWorkload":
        this.orderObj = { orderBy: "orderByMarkingWorkload", order: order };
        this.getData();
        break;
      //无效率(%)
      case "markingInefficiency":
        this.orderObj = { orderBy: "orderByMarkingInefficiency", order: order };
        this.getData();
        break;
      //有效评卷次数
      case "markingEffectiveNum":
        this.orderObj = { orderBy: "orderByMarkingEffectiveNum", order: order };
        this.getData();
        break;
      //平均评卷时间(min)
      case "markingAvgTime":
        this.orderObj = { orderBy: "orderByMarkingAvgTime", order: order };
        this.getData();
        break;
      //评价星级
      case "evaluateStar":
        this.orderObj = { orderBy: "orderByEvaluateStar", order: order };
        this.getData();
        break;
      //优秀教师
      case "otherinfoIsExcellentTeacherValue":
        this.orderObj = { orderBy: "orderByIsExcellentTeacher", order: order };
        this.getData();
        break;
    }
  }

  //点击手工评价
  private showTeacherEvaluateHandle() {
    if (this.chooseIdArray.length !== 1) {
      this.$message.warning("请勾选一条记录");
      return;
    }
    //显示评价详情
    this.showTeacherEvaluate = true;
  }

  //返回列表页
  private goBack(){
    // 释放文件引用
    if (this.iframe && this.iframe.src) {
      window.URL.revokeObjectURL(this.iframe.src);
    }

    this.$refs['iframeContainer'].removeChild(this.iframe);
    this.iframe = null
  }

  //预览pdf
 private previewPDF(res){
    //创建一个iframe
    this.iframe = document.createElement("iframe");
    this.iframe.setAttribute("frameborder", 0);
    this.iframe.style.width = "100%";
    this.iframe.style.height = "100%";
    this.$refs['iframeContainer'].appendChild(this.iframe);
    this.iframe.src = window.URL.createObjectURL(res);
  }
  //清空表格选中
  private clearSelection(){
    this.$refs['table'].clearSelection()
  }

  // 打印优秀证书
  private async printHandle() {
    if (this.chooseRowArray.length <= 0) {
      this.$message.warning("请勾选一条记录！");
      return false;
    }
    // if(this.chooseRowArray.length > 1) {
    //    this.$message.error("最多勾选一条记录！");
    //   return false;
    // }
    // let params = {
    //     projectId:  this.chooseRowArray[0][`projectId`], // 项目id
    //     teacherId:  this.chooseRowArray[0][`teacherId`] // 教师id
    //   }
    let arr = this.chooseRowArray.map(item => {
      return {
        projectId:  item[`projectId`], // 项目id
        teacherId:  item[`teacherId`], // 教师id
      }
    });
    try {
      let res: any;
      //  优秀证书
      res = await printContract(arr);
       this.clearSelection() //清空选择
        this.previewPDF(res) //预览pdf
    } catch (error) {
       this.clearSelection() //清空选择
      // this.$message.error(error || "操作失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }
  private async handleDownldTemplate() {
    try {
      if(!this.projectId){
        this.$message.warning("请选择项目！");
        return ;
      }
      (this as any).downloadHandle(
        "downloadMarkingTeacherEvaluateTemplate",
        "评卷教师评价模板.xlsx",
        {projectId: this.projectId}
      );
    } catch (error) {}
  }
  // 打印 方法
  private async commonDownloadHandle(res, fileFullName) {
    try {
      const blob: Blob = new Blob(
        [res],
        {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
        }
        // {type: 'application/pdf;charset=UTF-8'}
      );
      const patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
      const downloadElement = document.createElement("a");
      const href = window.URL.createObjectURL(blob); // 创建下载的链接
      downloadElement.style.display = "none";
      downloadElement.href = href;
      downloadElement.download = fileFullName; // 下载后文件名 单位管理模板.xlsx
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
      window.URL.revokeObjectURL(href); // 释放掉blob对象
      this.$message.success("下载成功");
    } catch (error) {
      // this.$message.error(error || "下载失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  // 每页条目变化时
  private handleSizeChange(val: number): void {
    this.pageSize = val;
    this.getData();
  }
  // 当前页发生改变时
  private handleCurrentChange(val: number): void {
    this.pageNo = val;
    this.getData();
  }
}
